import React from "react";
import Navbar from "../../layout/Navbar";
import Footer from "../../layout/Footer";
import bauxiteImg from "../../assets/Our Products/Bauxite/bauxite1.jpg";
import dataSheetImg from "../../assets/Our Products/Bauxite/data-bauxite.png";

const Bauxite = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* About Bauxite Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10 items-center">
          {/* Text Section */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              About <span className="text-orange-600">Bauxite</span>
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              JANTA Group produces high quality calcined bauxite for refractory,
              abrasives, proppants and anti-skid road surfacing applications.
              Calcined bauxite, an important raw material, is produced under a
              controlled environment of rotary kiln.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              Chemical and physical properties are monitored using
              state-of-the-art facilities. Stringent monitoring on the raw
              bauxite grade as feedstock and calcination process supported by a
              quality assurance system contribute towards achieving
              physicochemical conversion and improving bulk density.
            </p>
          </div>

          {/* Image Section */}
          <div className="flex justify-center md:justify-end relative">
            <img
              src={bauxiteImg}
              alt="Bauxite"
              className="w-80 h-80 object-cover rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </section>

      {/* Data Sheet Section (with Image) */}
      <section className="py-16 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-10">
            Product Data Sheet for <span className="text-orange-500">BAUXITE</span>
          </h2>

          <div className="flex justify-center">
            <img
              src={dataSheetImg}
              alt="Bauxite Data Sheet"
              className="rounded-1xl shadow-2xl border border-white/20 w-full sm:w-[80%] md:w-[70%] object-contain"
            />
          </div>
        </div>
      </section>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
          opacity: 0;
        }
      `}</style>

      <Footer />
    </div>
  );
};

export default Bauxite;

